export default "__VITE_ASSET__da7cbba5__"